// Function to open the accordion and trigger the filter click based on URL parameters
function openFiltersFromURL() {
	const urlParams = new URLSearchParams(window.location.search);

	// Loop through each URL parameter
	urlParams.forEach((value, key) => {
		console.log(key);
		console.log(value);
		// Find the corresponding filter button based on the key and value
		const filterButton = Array.from(
			document.querySelectorAll('.list-terms button')
		).find(button => {
			return (
				button.dataset.taxonomy === key.trim() &&
				button.dataset.term === value.trim()
			);
		});

		if (filterButton) {
			const accordion = filterButton.closest('.taxonomy-block');
			const content = accordion.querySelector('.taxonomy-content');

			// Trigger click on the filter button
			filterButton.click();
			// Open the accordion
			accordion.classList.add('js-active');
			content.style.maxHeight = `${content.scrollHeight}px`;
		}
	});
}

// Call the function to open filters from the URL on page load
openFiltersFromURL();
